import React from 'react';

type Props = {
  color?: string;
  width?: number;
};
export default function Dashboard({ color = '#0C57FF', width = 15 }: Props) {
  return (
    <svg
      width={width}
      height={(width * 15) / 16}
      viewBox={`0 0 15 16`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2391 14.394L14.2391 8.24036C14.2391 7.90051 13.9636 7.625 13.6237 7.625L7.4701 7.625C7.13024 7.625 6.85473 7.90051 6.85473 8.24036L6.85473 14.394C6.85473 14.7338 7.13024 15.0093 7.4701 15.0093H13.6237C13.9636 15.0093 14.2391 14.7338 14.2391 14.394Z"
        stroke={color}
        stroke-width="1.32078"
      />
      <path
        d="M14.2391 14.394L14.2391 8.24036C14.2391 7.90051 13.9636 7.625 13.6237 7.625L7.4701 7.625C7.13024 7.625 6.85473 7.90051 6.85473 8.24036L6.85473 14.394C6.85473 14.7338 7.13024 15.0093 7.4701 15.0093H13.6237C13.9636 15.0093 14.2391 14.7338 14.2391 14.394Z"
        stroke={color}
        stroke-width="1.32078"
      />
      <path
        d="M14.2391 4.54849V2.08704C14.2391 1.74719 13.9636 1.47168 13.6237 1.47168L7.4701 1.47168C7.13024 1.47168 6.85473 1.74719 6.85473 2.08704L6.85473 4.54849C6.85473 4.88835 7.13024 5.16385 7.4701 5.16385L13.6237 5.16385C13.9636 5.16385 14.2391 4.88835 14.2391 4.54849Z"
        stroke={color}
        stroke-width="1.32078"
      />
      <path
        d="M4.39328 14.394L4.39328 8.24036C4.39328 7.90051 4.11777 7.625 3.77792 7.625L1.31647 7.625C0.976613 7.625 0.701106 7.90051 0.701106 8.24036L0.701106 14.394C0.701106 14.7338 0.976613 15.0093 1.31647 15.0093H3.77792C4.11777 15.0093 4.39328 14.7338 4.39328 14.394Z"
        stroke={color}
        stroke-width="1.32078"
      />
      <path
        d="M4.39328 4.54849L4.39328 2.08704C4.39328 1.74719 4.11777 1.47168 3.77792 1.47168L1.31647 1.47168C0.976613 1.47168 0.701106 1.74719 0.701106 2.08704L0.701106 4.54849C0.701106 4.88835 0.976613 5.16385 1.31647 5.16385H3.77792C4.11777 5.16385 4.39328 4.88835 4.39328 4.54849Z"
        stroke={color}
        stroke-width="1.32078"
      />
    </svg>
  );
}
